module.exports = __webpack_public_path__ + "media/images/mbd-dashboard@2x-33b1511bddf2b9f30da61a9ebbcb23a5.webp";